module.exports = __webpack_public_path__ + "static/media/8783.80d3e0fc.png";